"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BalanceDropdown = function () {
    var _a, _b, _c, _d, _e, _f;
    var t = (0, next_intl_1.useTranslations)('translation');
    var pendingWithdrawals = (0, swr_hooks_1.usePendingWithdrawals)().data;
    var balance = (0, swr_hooks_1.useBalance)().data;
    var sortedBonuses = (0, swr_hooks_1.useBonusesCards)().sortedBonuses;
    var freespins = (0, swr_hooks_1.useFreespinsCards)().freespins;
    var pendingBalance = (0, swr_hooks_1.usePendingDeposits)().data;
    var lastDepositData = (0, swr_hooks_1.useLastDepositTransaction)().data;
    var lastTransaction = (_c = (_b = (_a = lastDepositData === null || lastDepositData === void 0 ? void 0 : lastDepositData.transaction) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0];
    var totalFreespins = (0, react_1.useMemo)(function () {
        return freespins.filter(function (bonus) {
            return bonus.status === profile_api_1.FreeRoundStatus.Active ||
                bonus.status === profile_api_1.FreeRoundStatus.InProgress ||
                bonus.status === profile_api_1.FreeRoundStatus.Pending;
        });
    }, [freespins]);
    var totalFreespinsAmount = (0, react_1.useMemo)(function () {
        if (!totalFreespins.length)
            return 0;
        return totalFreespins.reduce(function (acc, cur) { return acc + Number(cur.amount); }, 0);
    }, [totalFreespins]);
    var bonusesInQueueCount = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = sortedBonuses.filter(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.Pending; })) === null || _a === void 0 ? void 0 : _a.length;
    }, [sortedBonuses]);
    var hidePendingBalance = (0, react_1.useMemo)(function () {
        return (0, apps_shared_1.shouldHidePendingBalance)(pendingBalance, lastTransaction);
    }, [lastTransaction, pendingBalance]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            balance && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('balance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, "".concat((0, apps_shared_1.getCurrencySymbol)(balance.currency), " ").concat((_d = (Number(balance.totalAmount) || 0)) === null || _d === void 0 ? void 0 : _d.toFixed(2))))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
            balance && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('bonusBalance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, "".concat((0, apps_shared_1.getCurrencySymbol)(balance.currency), " ").concat((_e = ((Number(balance.totalAmount) || 0) -
                    (Number(balance.amount) || 0))) === null || _e === void 0 ? void 0 : _e.toFixed(2))))),
            balance && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('realBalance')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, "".concat((0, apps_shared_1.getCurrencySymbol)(balance.currency), " ").concat((_f = Number(balance.amount)) === null || _f === void 0 ? void 0 : _f.toFixed(2))))),
            pendingBalance && !hidePendingBalance && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.row, " ").concat(styles_module_scss_1.default.pendingWithdrawals) },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('pendingBalance')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, pendingBalance)))),
            pendingWithdrawals && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('pendingWithdrawals')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, pendingWithdrawals)))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.dividedLine }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('freespins')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, totalFreespinsAmount)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.prop }, t('bonusesQueue')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, bonusesInQueueCount)))));
};
exports.default = BalanceDropdown;
